import { render, staticRenderFns } from "./LoopItem.vue?vue&type=template&id=0a1b041b&"
import script from "./LoopItem.vue?vue&type=script&lang=js&"
export * from "./LoopItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports